import React, { FC, ChangeEvent } from 'react'
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap'

interface ModalFormValues {
  hs: string
  partial?: boolean | null
  hs_version: string
}

interface ModalAddHSCodeProps {
  show: boolean
  onHide: () => void
  onSubmit: () => void
  onDataChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
  values: ModalFormValues
  isLoading: boolean
  error: string | null
}

const ModalAddHSCode: FC<ModalAddHSCodeProps> = ({
  show,
  onHide,
  onSubmit,
  onDataChange,
  values,
  isLoading,
  error,
}) => {
  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>Add HS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mb-3'>
          <Form.Label>Code</Form.Label>
          <Form.Control
            placeholder='Enter HS code'
            type='text'
            name='hs'
            value={values.hs}
            onChange={onDataChange}
            disabled={isLoading}
          />
        </Form.Group>
        <Form.Group className='mb-3'>
          <Form.Label>Version</Form.Label>
          <Form.Select
            name='hs_version'
            value={values.hs_version}
            onChange={onDataChange}
            disabled={isLoading}
          >
            <option value='' disabled>
              Select HS Ver
            </option>
            <option value='H4'>H4</option>
            <option value='H5'>H5</option>
            <option value='H6'>H6</option>
          </Form.Select>
        </Form.Group>
        <Form.Group>
          <Form.Label>Partial</Form.Label>
          <Form.Select
            name='partial'
            value={
              values.partial === null
                ? ''
                : values.partial
                ? 'yes'
                : 'no'
            }
            onChange={onDataChange}
            disabled={isLoading}
          >
            <option value='' disabled>
              Select partial
            </option>
            {values.partial && (
            <option value=''>-- Clear selection --</option>
            )}
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </Form.Select>
        </Form.Group>
        {error && (
          <Alert variant='danger' className='mt-3'>
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='default' className='btn-cancel' onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={onSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Submitting...
            </>
          ) : (
            'Submit'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalAddHSCode
